import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import KcPosPaymentButton from "./KcPosPaymentButton"
import KcPlaceOrderButton from "./KcPlaceOrderButton"
import classes from "./KcFooter.module.scss"

const KcFooter = (props) => {
  const { paymentType } = props

  const [t] = useTranslation()

  const history = useHistory()

  const handleGoBack = () => {
    history.push("/kiosk-foods")
  }

  return (
    <div className={classes["container"]}>
      {
        paymentType === "pcPos" &&
        <KcPosPaymentButton />
      }

      {
        paymentType === "cod" &&
        <KcPlaceOrderButton />
      }

      <button
        className={classes["more"]}
        onClick={handleGoBack}
      >
        {t("سفارش_بیشتر")}
      </button>
    </div>
  )
}

export default KcFooter